import React from 'react';
import { connect } from 'react-redux';

import checkImg from '../../images/check.png';
import groupImg from '../../images/group.png';
import expandImg from '../../images/expand.png';
import collapeImg from '../../images/collapse.png';
import validationImg from '../../images/validation.png';
import uncheckImg from '../../images/uncheck.png';
import bookImg from '../../images/book.png';
import history from '../../history';
import util from '../../functions/Utilities';
import api from '../../api/api';
import uri from '../../variables/uri';
import messages from '../../variables/messages';
import SubHeader from './SubHeader';

class Authorize extends React.Component {
    state = {
        approver: undefined,
        isExpand: false,
        approverAmount: 0,
        isLoading: true,
        permissionList: []
    }

    componentDidMount = async () => {
        let amount = 0;
        if (this.props.authorize === undefined) {
            history.push(`/home/${this.props.match.params.userId}`)
        } else {
            const response = await api.get(`${uri.GET_PERMISSION_LIST}?PermissionGroupID=${this.props.topic.PermissionGroupID}`);
            this.props.authorize.forEach(element => {
                if (element.Approver) amount++;
            });
            this.setState({ approver: this.props.authorize.find(item => item.Approver), approverAmount: amount, isLoading: false, permissionList: response.data });
        }
    }

    onBackPressed() {
        history.goBack();
    }

    onExpand() {
        this.setState({ isExpand: !this.state.isExpand });
    }

    approverLevel(jl) {
        try {
            for (var i = 0; i <= this.state.permissionList.length; i++) {
                if (this.state.permissionList[i].PermissionValue >= jl) return this.state.permissionList[i].PermissionName;
            }
        } catch (ex) {
            console.log('ex')
            return null;
        }
    }

    onQuery() {
        history.push(`/ManageDoa/${this.props.match.params.userId}`);
    }

    render() {
        if (!this.state.isLoading)
            return (
                <div className="home flex-v">
                    <div className="flex-v flex-1">
                        <SubHeader text="Check Authorized" />
                        <div className="flex-v">
                            <div className="flex-h mt-16 ml-24" style={{ alignItems: 'center' }}>
                                <img src={bookImg} alt="" style={{ height: '25px' }} />
                                <h3 className="ml-16 text-center">Topic</h3>
                            </div>
                            <div className="flex-v card ml-16 mr-16 p-16">
                                <div className="grid-authorize-result">
                                    <h4>Requester:</h4>
                                    <h4 className="text-bold">{`${this.props.user.NamePrefixTH} ${this.props.user.FirstNameTH} ${this.props.user.LastNameTH}`}</h4>
                                </div>
                                <div className="grid-authorize-result">
                                    <h4>DOA Book:</h4>
                                    <h4 className="text-bold">{`${this.props.bookCode}`}</h4>
                                </div>
                                <div className="grid-authorize-result">
                                    <h4>Level 1:</h4>
                                    <h4 className="text-bold">{this.props.doa.levelOne}</h4>
                                </div>
                                <div className="grid-authorize-result">
                                    <h4>Level 2:</h4>
                                    <h4 className="text-bold">{this.props.doa.levelTwo}</h4>
                                </div>
                                {this.props.doa.levelThree !== 'Please select Level 3' &&
                                    <div className="grid-authorize-result">
                                        <h4>Level 3:</h4>
                                        <h4 className="text-bold">{this.props.doa.levelThree}</h4>
                                    </div>
                                }
                                {this.props.doa.levelFour !== 'Please select Level 4' &&
                                    <div className="grid-authorize-result">
                                        <h4>Level 4:</h4>
                                        <h4 className="text-bold">{this.props.doa.levelFour}</h4>
                                    </div>
                                }
                                {this.props.doa.levelFive !== 'Please select Level 5' &&
                                    <div className="grid-authorize-result">
                                        <h4>Level 5:</h4>
                                        <h4 className="text-bold">{this.props.doa.levelFive}</h4>
                                    </div>
                                }
                                {this.props.doa.levelSix !== 'Please select Level 6' &&
                                    <div className="grid-authorize-result">
                                        <h4>Level 6:</h4>
                                        <h4 className="text-bold">{this.props.doa.levelSix}</h4>
                                    </div>
                                }
                                {this.props.doa.levelSeven !== 'Please select Level 7' &&
                                    <div className="grid-authorize-result">
                                        <h4>Level 7:</h4>
                                        <h4 className="text-bold">{this.props.doa.levelSeven}</h4>
                                    </div>
                                }
                                <div className="grid-authorize-result">
                                    <h4>Amount:</h4>
                                    <h4 className="text-bold">{`${util.numberWithCommas(this.props.amount)}`}</h4>
                                </div>
                                {this.props.comments !== null &&
                                    <div className="grid-authorize-result">
                                        <h4>Comments:</h4>
                                        <h4 className="text-bold">{this.props.comments}</h4>
                                    </div>
                                }
                            </div>
                        </div>
                        {this.state.approver !== undefined &&
                            <div className="flex-v">
                                <div className="flex-h mt-16 ml-24" style={{ alignItems: 'center' }}>
                                    <img src={validationImg} alt="" style={{ height: '25px' }} />
                                    <h3 className="ml-16 text-center">Approver</h3>
                                </div>
                                <div className="flex-v card ml-16 mr-16 p-16">
                                    <div className="grid-authorize-result">
                                        <h4>Name:</h4>
                                        <h4 className="text-bold">{this.state.approver.MgrName}</h4>
                                    </div>
                                    <div className="grid-authorize-result">
                                        <h4>Email:</h4>
                                        <h4 className="text-bold">{this.state.approver.MgrEmail}</h4>
                                    </div>
                                    <div className="grid-authorize-result">
                                        <h4>Max Amount:</h4>
                                        <h4 className="text-bold">{this.state.approver.MaxAmount !== 'Unlimit' ? `${util.numberWithCommas(this.state.approver.MaxAmount)}` : this.state.approver.MaxAmount}</h4>
                                    </div>
                                    <div className="grid-authorize-result">
                                        <h4>Approver Level:</h4>
                                        <h4 className="text-bold">{this.props.gdc === 'CBM' ? this.state.approver.JL : `${this.approverLevel(this.state.approver.JL)} (${this.state.approver.JL})`}</h4>
                                    </div>
                                </div>
                            </div>
                        }
                        <div className="flex-h mt-16 ml-24" style={{ alignItems: 'center' }}>
                            <img src={groupImg} alt="" style={{ height: '30px' }} />
                            <h3 className="ml-16">Members of Organization</h3>
                        </div>
                        <div onClick={() => this.onExpand()} className="card  ml-16 mr-16 p-16 pointer">
                            {!this.state.isExpand ?
                                <div className="flex-h flex-between">
                                    <div className="flex-v flex-center flex-1 mr-16">
                                        <h3 className="has-text-centered mb-8">{this.state.approverAmount === 0 ? messages.NO_APPROVER : `${this.state.approverAmount} people can be approved.`}</h3>
                                        <div className="is-size-7">{`Tap to expand`}</div>
                                    </div>
                                    <img src={expandImg} alt="" style={{ height: '20px' }} />
                                </div>
                                : <div className="flex-v flex-between">
                                    <div className="flex-h flex-between bb pb-16" style={{ width: '100%' }}>
                                        <div className="flex-h flex-center flex-1">
                                            <div className="is-size-7">{`Tap again to collape`}</div>
                                        </div>
                                        <img src={collapeImg} alt="" style={{ height: '20px' }} />
                                    </div>
                                    {this.props.authorize.map((item, i) => {
                                        if (this.props.gdc === 'CBM' && (item.JL === '' || item.JL === null)) return <div />
                                        return (
                                            <div key={i} className="flex-h flex-between pb-8 pt-8 bb" style={{ width: '100%' }}>
                                                {item.Approver ? <img src={checkImg} alt="" style={{ width: '25px' }} /> : <img src={uncheckImg} alt="" style={{ width: '25px' }} />}
                                                <div className="flex-v flex-1 ml-16">
                                                    <div className="grid-authorize-result">
                                                        <h4>Name:</h4>
                                                        <h4 className="text-bold">{item.MgrName}</h4>
                                                    </div>
                                                    <div className="grid-authorize-result">
                                                        <h4>Email:</h4>
                                                        <h4 className="text-bold">{item.MgrEmail}</h4>
                                                    </div>
                                                    <div className="grid-authorize-result">
                                                        <h4>Max Amount:</h4>
                                                        <h4 className="text-bold">{item.MaxAmount !== 'Unlimit' ? `${util.numberWithCommas(item.MaxAmount)}` : item.MaxAmount}</h4>
                                                    </div>
                                                    <div className="grid-authorize-result">
                                                        <h4>Approver Level:</h4>
                                                        <h4 className="text-bold">{this.props.gdc === 'CBM' ? item.JL : `${this.approverLevel(item.JL)} (${item.JL})`}</h4>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>}
                        </div>
                    </div>
                    <div className="p-8">
                        <button onClick={() => this.onBackPressed()} className="button is-info is-fullwidth mt-8 center">Back</button>
                        <button onClick={() => this.onQuery()} className="button is-success is-fullwidth mt-8 center">DOA Book</button>
                    </div>
                </div>
            );

        return (
            <div className="flex-v flex-center" style={{ height: '100%' }}>
                Loading...
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        authorize: state.doa.authorize.Summary,
        doa: state.doa.doa,
        amount: state.doa.amount,
        comments: state.doa.authorize.Comments,
        user: state.doa.user,
        bookCode: state.doa.bookCode,
        topic: state.doa.selectedTopic,
        gdc: state.doa.gdc
    }
}

export default connect(mapStateToProps)(Authorize);